import _styled from "styled-components";
import React from "react";
import { graphql, type FragmentType } from "~/gql/runtime";
import { useNavLayout } from "~/features/app/landing-header/context";
const fragment = graphql(`
  fragment LandingNavLinks on navLinks_NeoField {
    __typename
    ...LandingNavLink
    ...LandingNavDropdown
  }
`);
type Props = {
  navLinks: FragmentType<typeof fragment>[];
};
const style = {
  transparent: {
    "borderColor": "rgba(255, 255, 255, 0.2)",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  solid: {
    "borderColor": "rgb(0 7 4 / 0.1)",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 239 246 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(0 7 4 / var(--tw-text-opacity))"
  },
  highlighted: {
    "borderColor": "rgb(0 7 4 / 0.1)",
    "backgroundColor": "var(--white-static)",
    "color": "var(--black-static)"
  }
};
export function NavLinks(props: Props) {
  const {
    navTheme,
    isPageHighlighted
  } = useNavLayout();
  const surface = isPageHighlighted ? "highlighted" : navTheme;
  return <_StyledNav $_css={[{
    "pointerEvents": "auto",
    "display": "flex",
    "height": "var(--header-height)",
    "alignItems": "center",
    "borderBottomWidth": "1px",
    "fontSize": "1.6rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.016rem",
    "fontWeight": "400"
  }, style[surface]]} />;
}
var _StyledNav = /*#__PURE__*/_styled("nav").withConfig({
  displayName: "nav-links___StyledNav",
  componentId: "sc-isk1p3-0"
})(["", ""], p => p.$_css);